<template>
  <div  >
    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            id="pr_id_btn"
            small
            block
            @click="pricestarifsMetrika"
            :disabled="btn_ability"
            color="primary"
            v-bind="attrs"
            v-on="on" >

          Цены и тарифы
          <v-tooltip v-if="help" bottom style="width: 32px;">
            <template v-slot:activator="{ on, attrs }">
               <v-btn v-bind="attrs"
                      v-on="on" style="margin-left: 4px;" x-small >?</v-btn>
            </template>

            <span> Информация о ценах и тарифах при заданных параметрах расчёта</span>
          </v-tooltip>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar
            dark
            color="primary"
        >
          <v-btn
              icon
              dark
              @click="dialog = false"
          >
            <v-icon>mdi-arrow-left-bold</v-icon>
          </v-btn>
          <v-toolbar-title>            Цены/тарифы на электрическую энергию и услуги для потребителя ( {{this.title}} )
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <v-card>
          <v-card-title>
          </v-card-title>
          <v-skeleton-loader  v-if="loading" type="table"></v-skeleton-loader>
          <v-simple-table v-if="!loading" class="text-center">
            <template v-slot:default>
            <tbody>
            <tr>
              <td rowspan="3" width="390" >Составляющие цены э/э</td>
              <td rowspan="3" width="390">Единица измерения</td>
              <td rowspan="3" width="106">1ЦК</td>
              <td style="border-bottom: 0px !important;" colspan="2" width="204">2ЦК</td>
              <td style="border-bottom: 0px !important;"  colspan="3" width="272">2ЦК</td>
              <td width="137">3ЦК</td>
              <td width="156">4ЦК</td>
            </tr>
            <tr>
              <td style="border-top: 0px !important;"  colspan="2">для двух зон суток</td>
              <td style="border-top: 0px !important;"  colspan="3">для трех зон суток</td>
              <td colspan="2">для каждого часа расчетного периода</td>
            </tr>
            <tr>
              <td>ночная</td>
              <td>дневная</td>
              <td>ночная</td>
              <td>полупиковая</td>
              <td>пиковая</td>
              <td colspan="2" width="293">среднее\средневзвешенное</td>
            </tr>
            <tr>
              <td class="text-left">Цена электроэнергии</td>
              <td class="text-left">руб/мВтч</td>
              <td>{{toRound(result.tr1.punc1ck)}}</td>
              <td>{{toRound(result.tr1.diff2_night_zone)}}</td>
              <td>{{toRound(result.tr1.diff2_day_zone)}}</td>
              <td>{{toRound(result.tr1.diff3_night_zone)}}</td>
              <td>{{toRound(result.tr1.diff3_halfpik_zone)}}</td>
              <td>{{toRound(result.tr1.diff3_pik_zone)}}</td>
              <td colspan="2" class="text-center">{{toRound(result.tr1.price3ck)}}<span v-if="!sum">*</span></td>
            </tr>
            <tr class="text-left">
              <td>Цена мощности</td>
              <td>руб/мВт в месяц</td>
              <td colspan="6" class="text-center">Не применяется</td>
              <td colspan="2" class="text-center">{{toRound(result.tr1_2.power)}}</td>
            </tr>
            <tr class="text-left">
              <td>Услуги по передаче э/э одноставочный тариф {{voltage_name}}</td>
              <td>руб/мВтч</td>
              <td colspan="7" class="text-center">{{toRound(result.tr2.transfer_service_vl)}}</td>
              <td>не применяется</td>
            </tr>
            <tr class="text-left">
              <td>Услуги по передаче э/э ставка за компенсацию потерь {{voltage_name}}</td>
              <td>руб/мВтч</td>
              <td colspan="7" class="text-center">не применяется</td>
              <td>{{toRound(result.tr3.transfer_service)}}</td>
            </tr>
            <tr class="text-left">
              <td>Услуги по передаче э/э ставка за содержание сетей {{voltage_name}}</td>
              <td> руб/мВт в месяц</td>
              <td colspan="7" class="text-center">не применяется</td>
              <td>{{toRound(result.tr4.transfer_service)}}</td>
            </tr>
            <tr class="text-left">
              <td>Плата за иные услуги</td>
              <td>руб/мВтч</td>
              <td colspan="8" class="text-center">{{toRound(result.tr5.ip)}}</td>
            </tr>
            <tr class="text-left">
              <td>Сбытовая надбавка ГП {{ category_name }}</td>
              <td>руб/мВтч</td>
              <td colspan="8" class="text-center">{{toRound(result.tr8.sn)}}</td>
            </tr>
            <tr >
              <td class="text-left">Цена электроэнергии для потребителя (без НДС)</td>
              <td class="text-left">руб/мВтч</td>
              <td class="text-center">{{toRound(parseFloat(result.tr1.punc1ck)+parseFloat(result.tr2.transfer_service_vl)+parseFloat(result.tr5.ip)+parseFloat(result.tr8.sn))}}</td>
              <td class="text-center">{{toRound(parseFloat(result.tr1.diff2_night_zone)+parseFloat(result.tr2.transfer_service_vl)+parseFloat(result.tr5.ip)+parseFloat(result.tr8.sn))}}</td>
              <td class="text-center">{{toRound(parseFloat(result.tr1.diff2_day_zone)+parseFloat(result.tr2.transfer_service_vl)+parseFloat(result.tr5.ip)+parseFloat(result.tr8.sn))}}</td>
              <td class="text-center">{{toRound(parseFloat(result.tr1.diff3_night_zone)+parseFloat(result.tr2.transfer_service_vl)+parseFloat(result.tr5.ip)+parseFloat(result.tr8.sn))}}</td>
              <td class="text-center">{{toRound(parseFloat(result.tr1.diff3_halfpik_zone)+parseFloat(result.tr2.transfer_service_vl)+parseFloat(result.tr5.ip)+parseFloat(result.tr8.sn))}}</td>
              <td class="text-center">{{toRound(parseFloat(result.tr1.diff3_pik_zone)+parseFloat(result.tr2.transfer_service_vl)+parseFloat(result.tr5.ip)+parseFloat(result.tr8.sn))}}</td>
              <td class="text-center">{{toRound( parseFloat(result.tr1.price3ck) +parseFloat(result.tr1_2.power)/daysCount/24+parseFloat(result.tr2.transfer_service_vl) + parseFloat(result.tr5.ip)  +parseFloat(result.tr8.sn)) }}</td>
              <td class="text-center">{{toRound( parseFloat(result.tr1.price3ck) +parseFloat(result.tr1_2.power)/daysCount/24+parseFloat(result.tr3.transfer_service)+parseFloat(result.tr4.transfer_service)/1000 + parseFloat(result.tr5.ip)  +parseFloat(result.tr8.sn)) }}</td>
            </tr>
            </tbody>
            </template>
          </v-simple-table>
          <v-alert
              v-if="!sum"
              border="right"
              color="blue-grey"
              dark
          >
            * - выведено среднее значение. Для расчета Вашей цены необходимо    <v-btn
              color="primary"
              small
              @click="dialog = false"
          > ввести объем
          </v-btn>
          </v-alert>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props:['help','open','sum','category_name','btn_ability','zone_id','region_id','month','year','category','voltage_level','title','host','arr','voltage_name'],
  name: 'PricesTarifs',
  data () {
    return {
      show:true,
      loading:true,
      result:{
        tr1:{
          punc1ck:'0',
          diff2_night_zone:"0",
          diff2_day_zone:"0",
          diff3_night_zone:'0',
          diff3_pik_zone:'0',
          diff3_halfpik_zone:'0',
          price3ck:'0'
        },
        tr1_2:{
          power:'0',
        },
        tr2:{
          transfer_service_vl:'0'
        },
        tr3:{
          transfer_service:'0'
        },
        tr4:{
          transfer_service:'0'
        },
        tr5:{
          ip:'0'
        },
        tr6:{
          it_cfr:'0'
        },
        tr7:{
          it_so_ees:'0'
        },
        tr8:{
          sn:'0'
        }


      },
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      rdata:{
        punc1:'--punc1--'
      }
    }
  },
  methods:{
    pricestarifsMetrika(){
      this.$metrika.reachGoal('pricestarifs');
    },
    toRound(val) {
      var result = Math.round(val * 100) / 100;
      return result.toLocaleString('ru');
    },
    getResult(){
      var sum = 0;
      var arr = [];
      for (let i = 0; i < this.arr.length; i++) {
        var sarr = this.arr[i];
        arr[i] = [];
        for (let j = 0; j < sarr.length; j++) {
          if (this.mv == 'kvt') {
            arr[i][j] = sarr[j];
          } else {
            arr[i][j] = sarr[j];
          }
          sum = sum + arr[i][j]['value'];
        }
      }
      var req={
        month:this.month,
        contract_type:'dkp',
        type:'kvt',
        year:this.year,
        zone_id:this.zone_id,
        region_id:this.region_id,
        voltage_level:this.voltage_level,
        category:this.category,
        sum:sum,
        volume: JSON.stringify(arr)
      };
      axios.post(this.host+"/tariffs/test",req)
          .then((response)=>{
            this.result.tr1=response.data.tr1;
            this.result.tr1_2=response.data.tr1_2;
            this.result.tr2=response.data.tr2;
            this.result.tr3=response.data.tr3;
            this.result.tr4=response.data.tr4;
            this.result.tr5=response.data.tr5;
            this.result.tr5=response.data.tr5;
            this.result.tr6=response.data.tr6;
            this.result.tr7=response.data.tr7;
            this.result.tr8=response.data.tr8;
            this.loading=false;

          })
    }
  },
  computed:{

    daysCount() {
      return new Date(this.year, this.month, 0).getDate();
    },
    years() {
      const currentYear = (new Date()).getFullYear();
      const range = (start, stop, step) => Array.from({length: (stop - start) / step + 1}, (_, i) => start + (i * step));
      return (range(currentYear, 2019, -1));
    },
  },
  mounted() {

  },
  watch:{
    open:{
      handler(){
        this.dialog=this.open;
      }
    },
    dialog:{
      handler(){
        this.getResult();
      }
    }
  }
}
</script>
<style scoped>
td {
  border: #B2BABB 1px solid;
}
th {
  border: #B2BABB 1px solid;
}
</style>
